module.exports = __webpack_public_path__ + "img/ru.83f556eb.svg";